import Select from '../../SidePanel/RightPanel/PropertiesControllerSelect.jsx'
import {useProperties} from '../../SidePanel/RightPanel/Properties.mjs'
import useDriver from './useDriver.mjs'

export default function PropertiesControllerDriver(props) {
    const [{dbmsCode}] = useProperties()
    const {pairs} = useDriver({databaseType: dbmsCode})

    return (
        <Select
            mapOption={{label: e => e.driverName}}
            options={pairs}
            prop="dbInsDriverId"
            {...props}
        />
    )
}
